import { atom } from "jotai";
import {
  SortAndFilterOptions,
  defaultSortAndFilterOptions,
  GroupSortAndFilterOptions,
  defaultGroupSortAndFilterOptions,
} from "shared/models";

export const sortFilterOptionsAtom = atom<SortAndFilterOptions>(
  defaultSortAndFilterOptions
);

export const groupSortFilterOptionsAtom = atom<GroupSortAndFilterOptions>(
  defaultGroupSortAndFilterOptions
);
